import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClosing() {
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('main-cta');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="comprar-ahora" className="relative py-16 md:py-24 px-4 bg-bg-secondary overflow-hidden" data-id="element-22">
      {/* Decorative floral SVG */}
      <div className="absolute bottom-0 left-0 w-64 h-64 opacity-10 pointer-events-none" data-id="element-23">
        <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-24">
          <path d="M50 100C50 100 70 80 90 80C110 80 120 90 120 100C120 110 110 120 90 120C70 120 50 100 50 100Z" fill="#EFCFD3" data-id="element-25" />
          <path d="M120 100C120 100 140 80 160 80C180 80 190 90 190 100C190 110 180 120 160 120C140 120 120 100 120 100Z" fill="#DCCFEA" data-id="element-26" />
          <circle cx="100" cy="100" r="15" fill="#B89BB8" data-id="element-27" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-28">
        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-heading mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          Una última cosa antes de que te vayas
        </motion.h2>

        <motion.div className="space-y-6 text-lg md:text-xl text-body leading-relaxed mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-30">
          <p data-id="element-31">
            Cada día que pasa sin información clara es un día más de confusión,
            de tratamientos a ciegas y de molestias que podrían evitarse o
            manejarse mejor.
          </p>

          <p className="font-semibold" data-id="element-32">No mereces seguir adivinando.</p>

          <p data-id="element-33">
            Mereces entender tu cuerpo. Mereces cuidarte con información real.
            Mereces no tener miedo cada vez que aparece un síntoma.
          </p>

          <p className="font-semibold" data-id="element-34">
            Eso es exactamente lo que esta guía puede darte.
          </p>
        </motion.div>

        <motion.a href="https://www.tumundoequilibrado.com/cart/51443310887207:1" className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6 rounded-2xl px-6 py-5 sm:px-8 sm:py-6 text-white shadow-xl hover:shadow-2xl transition-all duration-300" style={{
        background: 'linear-gradient(135deg, #D6217A 0%, #E91E8C 50%, #FF3DA0 100%)'
      }} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} whileHover={{
        scale: 1.04
      }} whileTap={{
        scale: 0.96
      }} data-id="element-35">
          <div className="flex items-center gap-3 sm:gap-4" data-id="element-36">
            <div className="flex flex-col items-center leading-none" data-id="element-37">
              <span className="text-[10px] sm:text-xs uppercase tracking-wider opacity-80" data-id="element-38">
                Antes
              </span>
              <span className="text-base sm:text-lg font-semibold line-through opacity-70" data-id="element-39">
                $15,99
              </span>
            </div>
            <div className="w-px h-10 bg-white/40" data-id="element-40"></div>
            <div className="flex flex-col items-center leading-none" data-id="element-41">
              <span className="text-[10px] sm:text-xs uppercase tracking-wider opacity-90" data-id="element-42">
                Ahora
              </span>
              <span className="font-heading text-2xl sm:text-3xl font-extrabold" data-id="element-43">
                $11,99
              </span>
            </div>
          </div>
          <span className="bg-white text-[#D6217A] px-5 py-2.5 rounded-full font-bold text-sm sm:text-base shadow-md" data-id="element-44">
            🛒 Comprar ahora
          </span>
        </motion.a>
      </div>
    </section>;
}